import {DialogFragment, PageFragment, PageFragmentProps} from "@/shared/PageFragment";
import {Box} from "@mui/material";
import {FormGenContainer, FormGenContainerMode} from "@/shared/FormGenContainer";
import {PAGE_FRAGMENT_LG_WIDTH} from "@/shared/dimens";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React from "react";
import {Patient, Patients} from "../../../zyrcona-shared/types";

export class EditPatientHelper {

  static addPatient() {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditPatientFragment onPatientSaved={patient => BaseApp.CONTEXT.hideDialog()}/>);
  }

  static editPatient(patient: Patient) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditPatientFragment
        edit={patient}
        onPatientSaved={patient => BaseApp.CONTEXT.hideDialog()}/>);
  }
}

type EditPatientFragmentProps = PageFragmentProps & {
  edit?: Patient,
  onPatientSaved: (patient: Patient) => void,
}

class EditPatientFragment extends DialogFragment<EditPatientFragmentProps> {

  private readonly patients = Patients.getInstance();
  private readonly patient = this.props.edit ? this.props.edit : Patient.createNew();

  protected onCreateState() {
    return {
      ...super.onCreateState(),
      title: this.props.edit ? "Edit " : "Add ",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return this.props.edit ? "Save" : "Add";
  }

  onActionButtonClicked() {
    this.addPatient().then(() => this.props.onPatientSaved(this.patient));
  }

  private async addPatient() {
    await this.patients.addListItem(this.patient);
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", width: "92dvw", maxWidth: PAGE_FRAGMENT_LG_WIDTH}}>
      <FormGenContainer
        mode={this.props.edit ? FormGenContainerMode.EDIT : FormGenContainerMode.CREATE}
        content={this.patient}
        onContainerRequiredItemsFilledChanged={(container, filled) => this.setActionButtonEnabled(filled)}/>
    </Box>;
  }
}
